import Vue from 'vue';
import Bars from 'vuebars';
import Toasted from 'vue-toasted';

import VueTranslator from 'vue-translator';

import App from './App.vue';

import czechTranslates from './translations/cs';


import store from './store';
import router from "./router/index";

import './assets/app.less';

Vue.config.productionTip = false;

Vue.use(VueTranslator,{
  locale: 'cs',
  translations: {
    cs: czechTranslates
  },
  defaultLocale: 'cs'
});

Vue.use(Bars);
Vue.use(Toasted,{
  position: 'top-center',
  duration: 3500
});

import vueMoment from 'vue-moment';

const moment = require('moment');
require('moment/locale/cs');
Vue.use(vueMoment,{
  moment
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
